"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _spacing = _interopRequireDefault(require("@decisiv/design-tokens/lib/spacing"));

var _Button = _interopRequireDefault(require("../Button"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var StyledButton = (0, _styledComponents.default)(_Button.default).withConfig({
  displayName: "StyledButton",
  componentId: "sc-128m29n-0"
})(["margin-left:auto;height:", ";width:", ";& svg{height:", ";width:", ";}"], (0, _rem.default)(_spacing.default.base * 1.2), (0, _rem.default)(_spacing.default.base * 1.2), (0, _rem.default)(_spacing.default.base * 1.2), (0, _rem.default)(_spacing.default.base * 1.2));
var _default = StyledButton;
exports.default = _default;